import React from 'react';
import styled from 'styled-components';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

interface TableDragProps {
  id: string | number;
  content: string;
  edit: boolean;
  className?: string;
  editPhases: (id: string | number) => void;
  onKeyDownEdit: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  handleChangeEdit: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectValue: string;
  saveEditPhase: (id: string | number) => void;
  clickDelete: (id: string | number) => void;
}

const TrWrapper = styled.tr<{ isDragging?: boolean }>`
  background: #fff;
  cursor: default;
  opacity: ${({ isDragging }) => (isDragging ? 0.5 : 1)};

  .row-div {
    display: flex;
    flex-direction: row;
    width: 335px;
  }

  .td-final {
    width: 15%;
    border-left: 1px solid #fff;
  }

  &.helperContainerClass {
    width: auto;
    border: 1px solid #efefef;
    box-shadow: 0 5px 5px -5px rgba(0, 0, 0, 0.2);
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 3px;
    z-index: 50;

    &:active {
      cursor: grabbing;
    }

    & > td {
      padding: 5px;
      text-align: left;
      width: 100px;
    }
  }
`;

const Handle = styled.div`
  margin-right: 10px;
  padding: 0 5px;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

const TableDrag: React.FC<TableDragProps> = ({
  id,
  content,
  edit,
  className,
  editPhases,
  onKeyDownEdit,
  handleChangeEdit,
  selectValue,
  saveEditPhase,
  clickDelete,
}) =>
{
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition: !isDragging ? 'none' : transition,
  };

  return (
    <TrWrapper
      ref={setNodeRef}
      style={style}
      className={className}
      isDragging={isDragging}
      {...attributes}
    >
      <td>
        <div className="row-div">
          {/* Drag handle — only this element triggers the drag */}
          <Handle ref={setActivatorNodeRef} {...listeners}>
            <span className="drag-icon-control-new-phase" />
          </Handle>

          {!edit ? (
            <td className="drag-icon-contener td-middle" onDoubleClick={() => editPhases(id)}>
              {content}
            </td>
          ) : (
            <td className="drag-icon-contener td-middle">
              <input
                id="input-edit-phases"
                className="corgee-input corgee-input-with-btn"
                type="text"
                aria-invalid="false"
                onKeyDown={onKeyDownEdit}
                onChange={handleChangeEdit}
                value={selectValue}
              />
              <a className="corgee-button corgee-edit-phase" onClick={() => saveEditPhase(id)}>
                Update
              </a>
            </td>
          )}

          <td className="td-final" onClick={() => clickDelete(id)}>
            <i className="icon-trash-icon trash-create-phase" />
          </td>
        </div>
      </td>
    </TrWrapper>
  );
};

export default TableDrag;
